import React, { forwardRef, useContext, useMemo } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { BoxClass, OneNode } from '../../../helper/classes'
import { uniqueId } from 'lodash'
import { GlobalContext, globalOnDemandVars } from '../../../helper/context'
import { Popover, Tag, HTMLTable, Button, Tooltip } from '@blueprintjs/core'
import { OverlayProps, TutorialVideoConfig } from '../../../helper/configs'
import { CommonRender, CommonThumbnail } from './parts/forEachInsertForm/common'
import { DragSource } from 'react-dnd'
import DragDropContextHOC from '../../../helper/DragDropContext'
import { produce } from 'immer'
import YouTube from 'react-youtube'

const externalNodeType = 'toSortableTree'
const externalNodeSpec = {
  beginDrag: (componentProps) => ({
    node: { ...componentProps.node },
    parentNode: null,
    path: [],
    rootPath: { length: -1 },
    treeIndex: 0,
    treeId: uniqueId()
  }),
  endDrag: (props, monitor) => {
    if (process.env.NODE_ENV !== 'production') {
      console.tron.display({
        name: 'uploadType2 / endDrag in uploadType2 node',
        value: {
          didDrop: monitor.didDrop(),
          getDropResult: monitor.getDropResult(),
          props
        }
        // , important: true
      })
    }
    if (monitor.didDrop()) {
      if (!globalOnDemandVars.isPixelMode()) {
        const uploadType2Id = props.node.uploadType2Id
        const uploadType2 = globalOnDemandVars.uploadType2s()[uploadType2Id]
        uploadType2.clear()
        uploadType2.setInWaitingList(false)
        globalOnDemandVars.set_uploadType2sInWaitingList(produce(globalOnDemandVars.uploadType2sInWaitingList(), draft => {
          draft.splice(props.index, 1)
        }))
      }
    }
  }
}

const externalNodeCollect = (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging()
})

class InnerExternalNodeBaseComponent extends React.PureComponent {
  render () {
    if (process.env.NODE_ENV !== 'production') {
      console.tron.display({
        name: 'uploadType2 / InnerExternalNodeBaseComponent',
        value: {
          props: this.props,
          ready: globalOnDemandVars.uploadType2Ready(),
          uploadType2s: globalOnDemandVars.uploadType2s()
        }
        // , important: true
      })
    }
    const { connectDragSource, node } = this.props
    const uploadType2 = globalOnDemandVars.uploadType2s()[node.uploadType2Id]
    const content = uploadType2.content
    return connectDragSource(
      <div>
        <Popover {...OverlayProps} canEscapeKeyClose={false} interactionKind={'hover-target'} content={
          <div css={css`width: 400px;`}>{uploadType2.type === 'Image'
            ? <CommonRender type={uploadType2.type} contentData={content} />
            : <CommonThumbnail type={uploadType2.type} contentData={content} />
          }</div>
        }>
          <Tag icon='heat-grid' intent='success' minimal large interactive css={css`cursor: grab !important;`}>
            {uploadType2.title}
          </Tag>
        </Popover>
      </div>
    )
  }
}

const ExternalNodeBaseComponent = DragSource(
  externalNodeType, externalNodeSpec, externalNodeCollect
)(InnerExternalNodeBaseComponent)

function InnerUploadType2AddOn () {
  const context = useContext(GlobalContext)

  return useMemo(() => {
    const uploadType2sInWaitingList = context.uploadType2sInWaitingList

    return <div>
      <Tooltip {...OverlayProps} targetTagName={'div'} content={'Generating Cloze with Media'}>
        <Button icon={'help'} minimal fill text='Help' onClick={() => {
          globalOnDemandVars.openGlobalDialog()('Upload Media (Type 2)', <YouTube
            videoId={'Uy3lybqcNv8'} {...TutorialVideoConfig} />, 'bigger', true)
        }} /></Tooltip>
      {(!context.uploadType2Ready ? null
        : <HTMLTable>
          {uploadType2sInWaitingList.map((uploadType2, index) => {
            const nodeBase = new OneNode()
            nodeBase.isUploadType2 = true
            nodeBase.uploadType2Id = uploadType2.id
            nodeBase.title = uploadType2.title

            return (
              <tr>
                <td>
                  <ExternalNodeBaseComponent node={nodeBase} index={index} />
                </td>
              </tr>
            )
          })}
        </HTMLTable>)}
    </div>
  }, [context.uploadType2Ready, context.uploadType2sInWaitingList])
}

// eslint-disable-next-line no-func-assign
InnerUploadType2AddOn = forwardRef(InnerUploadType2AddOn)

const UploadType2AddOn = DragDropContextHOC(InnerUploadType2AddOn)

const UploadType2AddOnBoxClass = new BoxClass(UploadType2AddOn, 'Upload Type 2 ', null, 2, { order: 2 })

export default UploadType2AddOnBoxClass
